import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProfileState } from '@et/guards';
import { Profile } from '@et/typings';
import { Store } from '@ngxs/store';
import { filter, first } from 'rxjs';

export const profileResolver: ResolveFn<Profile> = () => {
  return inject(Store)
    .select(ProfileState.getFullProfile)
    .pipe(filter(Boolean), first());
};
